import React from "react";
import { Spin, Empty } from "antd";
import style from "./LoadingWrapper.module.scss";

interface LoadingWrapperProps {
    loading: boolean;
    isEmpty: boolean;
    emptyMessage?: string;
    children: () => React.ReactChild | React.ReactChild[];
}

export default function LoadingWrapper({
    loading,
    isEmpty,
    emptyMessage,
    children
}: LoadingWrapperProps) {
    return (
        <>
            {!loading && !isEmpty && children()}
            {loading && (
                <div className={style.root}>
                    <Spin size="large" />
                </div>
            )}
            {!loading && isEmpty && <Empty />}
        </>
    );
}
